import { ArrowLeft, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function StitchFlowLayout({
  children,
  title = "Pleiades Rehberlik",
  backTo,
  backLabel = "Geri dön",
  showMenu = false,
  contentClassName = "",
  pageClassName = "",
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const accountPath = "/giris";

  return (
    <div className={`stitch-flow-page ${pageClassName}`.trim()}>
      <div className="stitch-flow-viewport">
        <header className="stitch-flow-topbar" data-testid="stitch-flow-header">
          <div className="stitch-flow-topbar-row">
            <div className="stitch-flow-topbar-side">
              {backTo ? (
                <Link to={backTo} className="stitch-icon-button" aria-label={backLabel}>
                  <ArrowLeft size={24} strokeWidth={2} aria-hidden="true" />
                </Link>
              ) : null}
            </div>

            <h1 className="stitch-flow-topbar-title">{title}</h1>

            <div className="stitch-flow-topbar-side stitch-flow-topbar-side-end">
              {showMenu ? (
                <button
                  type="button"
                  className="stitch-menu-button"
                  aria-label={menuOpen ? "Menüyü kapat" : "Menüyü aç"}
                  aria-expanded={menuOpen}
                  aria-controls="stitch-flow-menu"
                  onClick={() => setMenuOpen((current) => !current)}
                >
                  {menuOpen ? (
                    <X size={20} strokeWidth={2} aria-hidden="true" />
                  ) : (
                    <Menu size={20} strokeWidth={2} aria-hidden="true" />
                  )}
                  <span>{menuOpen ? "Kapat" : "Menü"}</span>
                </button>
              ) : null}
            </div>
          </div>

          {menuOpen ? (
            <nav id="stitch-flow-menu" className="stitch-flow-menu" aria-label="Ana menü">
              <Link to="/" onClick={() => setMenuOpen(false)}>
                Ana sayfa
              </Link>
              <Link to={accountPath} onClick={() => setMenuOpen(false)}>
                Hesabım
              </Link>
            </nav>
          ) : null}
        </header>

        <main
          className={`stitch-flow-content ${contentClassName}`.trim()}
          data-testid="stitch-flow-scroll"
        >
          {children}
        </main>
      </div>
    </div>
  );
}
